module.exports = __webpack_public_path__ + "static/img/bonus_0.d100c17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fu_shen/bonus_0.png
// module id = 3xLy
// module chunks = 0